import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);
const hotArticles = articles.filter((a) => a.hot).slice(0, 6);
const recentArticles = articles.slice(0, 8);

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料导航',
    url: 'https://heiliaodaohang.com',
    description: '黑料导航为你精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容，一站式导航直达各大黑料平台与资源站点。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliaodaohang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料导航',
    url: 'https://heiliaodaohang.com',
    description: '最全娱乐黑料聚合平台',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料导航 - 最全娱乐黑料聚合平台',
    description: '黑料导航为你精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容，一站式导航直达各大黑料平台与资源站点。',
    url: 'https://heiliaodaohang.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料导航',
      url: 'https://heiliaodaohang.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="黑料导航 - 最全娱乐黑料聚合平台 | 明星黑料、网红爆料一网打尽"
        description="黑料导航为你精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容，一站式导航直达各大黑料平台与资源站点，省时高效，内容持续更新，让你第一时间掌握最新黑料动态。"
        keywords="黑料导航,黑料平台导航,娱乐黑料聚合,明星黑料网站,网红爆料导航,黑料资源入口,最新黑料合集"
        canonicalUrl="https://heiliaodaohang.com"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20news%20website%20homepage%2C%20bold%20and%20dramatic%20layout%2C%20red%20and%20black%20color%20scheme%2C%20breaking%20news%20style%2C%20modern%20web%20design&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{ ...websiteSchema, ...organizationSchema, ...webPageSchema }}
      />

      <Navbar />

      <main>
        <section className="relative pt-16">
          <div className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20theater%20stage%20with%20red%20velvet%20curtains%20partially%20opened%2C%20mysterious%20spotlight%20casting%20long%20shadows%2C%20backstage%20atmosphere%2C%20cinematic%20lighting%2C%20bold%20contrast%2C%20entertainment%20industry%20theme%2C%20premium%20editorial%20style&width=1800&height=900&seq=hero-home&orientation=landscape"
              alt="黑料导航 - 娱乐黑料聚合平台"
              title="黑料导航 - 最全娱乐黑料聚合平台"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white px-4 w-full max-w-3xl">
                <h1 className="text-2xl md:text-5xl font-heading mb-4 leading-tight">
                  全网黑料 · 一站聚合
                </h1>
                <p className="text-sm md:text-lg text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
                  娱乐黑料、明星丑闻、网红爆料，精准聚合全网最热内容，持续更新，让你第一时间掌握最新黑料动态
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/mingxing-heiliao"
                    className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    立即浏览 <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full whitespace-nowrap backdrop-blur-sm transition-colors cursor-pointer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    了解我们
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                  <i className="ri-fire-line text-primary-500 mr-2"></i>
                  精选爆料
                </h2>
                <p className="text-sm text-foreground-500 mt-1">编辑精选的最热黑料内容</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                  <i className="ri-flashlight-line text-accent-500 mr-2"></i>
                  分类导航
                </h2>
                <p className="text-sm text-foreground-500 mt-1">按分类浏览你感兴趣的黑料内容</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 group cursor-pointer"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-3 group-hover:bg-primary-200 transition-colors">
                    <i className={`${cat.icon} text-lg text-primary-600`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{cat.name}</h3>
                  <p className="text-xs text-foreground-400">{cat.articleCount} 篇内容</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                  <i className="ri-bar-chart-line text-primary-500 mr-2"></i>
                  热榜飙升
                </h2>
                <p className="text-sm text-foreground-500 mt-1">实时热度飙升的黑料内容</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                  <i className="ri-article-line text-secondary-500 mr-2"></i>
                  最新更新
                </h2>
                <p className="text-sm text-foreground-500 mt-1">实时更新的最新黑料文章</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {recentArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-xl md:text-3xl font-heading mb-4">不想错过任何黑料？</h2>
              <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-6">
                订阅我们的黑料速报，第一时间获取最新娱乐黑料、明星丑闻、网红爆料推送
              </p>
              <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto items-center justify-center">
                <input
                  type="email"
                  placeholder="输入你的邮箱地址"
                  className="w-full sm:flex-1 px-4 py-3 rounded-full text-sm text-foreground-900 bg-white border-0 outline-none"
                />
                <button className="px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer">
                  立即订阅
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}